import React from 'react';

const CustomerInput = ({ value, onChange, placeHolder, inputStyles, name, disabled,onBlur,type,disableCopyPaste }) => {
    const handleCopyPaste = (e) => {
        if(disableCopyPaste===true){
            e.preventDefault();
        }else{
            return null;
        }
    };
    return (
        <div>
            <div className="mt-2">
                <input
                    value={value}
                    onChange={onChange}
                    style={inputStyles}
                    id="customer"
                    placeholder={placeHolder ? placeHolder : ''}
                    name={name ? name : ''}
                    type={type?type:"text"}
                    onCopy={handleCopyPaste}  // Disable copying
                    onPaste={handleCopyPaste} // Disable pasting
                    onCut={handleCopyPaste}   // Disable cutting
                    autoComplete="customer"
                    required
                    onBlur={onBlur}
                    disabled={disabled}
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
            </div>
        </div>
    );
};

export default CustomerInput;
